import ADSButton from "../../../../../../../../../ADSButton";
import styles from "./ImageEditorTrigger.module.scss";
import { useImageEditorContext } from "../../../../../../../../../../context/ImageEditorProvider";
import { useAIToolsContext } from "../../../../../../../../../../context/AIToolsProvider";

const ImageEditorTrigger = () => {
  const { selectedAITools } = useAIToolsContext();
  const { isEditingImage, setIsEditingImage } = useImageEditorContext();

  const disabled = isEditingImage || !!selectedAITools;

  return (
    <ADSButton
      className={`${styles.wrapper} ${disabled ? styles.disabled : ""}`}
      disabled={disabled}
      onClick={() => setIsEditingImage(true)}
      style={{ borderRadius: "20px" }}
    >
      Edit
    </ADSButton>
  );
};

export default ImageEditorTrigger;
